export default "__VITE_ASSET__D4HsaXw2__"